<template>
  <div class="d-flex flex-column">
    <!-- First line: Applicant count and action buttons -->
    <div class="d-flex flex-wrap align-items-center mt-2" style="gap: 15px; margin-right: 55px">
      <div
        v-if="!aiMode"
        class="showing-div"
        style="color:#000000 !important;font-weight: bold;"
      >
        <div v-if="applicantsCount.total != 0">
          <template v-if="applicantsCount.total === 1">
            1名表示 / 1名登録
          </template>
          <template v-else>
            {{ applicantsCount.from }}-{{ applicantsCount.to }}名表示 /
            {{ applicantsCount.total }}名 {{ isReviewer ? '登録' : 'リスト' }}
          </template>
        </div>
      </div>

      <!-- Assigned List Name display for non-reviewers -->
      <!-- <div v-if="!isReviewer" class="d-flex align-items-center ms-5">
        <span class="me-3" style="font-weight: bold; color: #3c3c3c; white-space: nowrap;">表示中のリスト</span>
        <div class="list-name-box">
          {{ assignedReviewListName }}
        </div>
      </div> -->
      
      <!-- Icon buttons container for reviewer -->
      <div v-if="isReviewer && !aiMode" class="d-flex align-items-start" style="gap: 20px; margin-left: 30px;">
        <!-- Favorite button with label -->
        <div class="icon-button-wrapper">
          <div class="favorite-wrapper tooltip-container" @click="toggleFavoriteApplicants">
            <Favorite :favorite="favoritesOnly" :fromSearchBar="true" />
          </div>
          <span class="icon-text-label">ブックマーク絞込</span>
        </div>
        
        <!-- Interview button with label -->
        <div class="icon-button-wrapper">
          <div class="favorite-wrapper tooltip-container" @click="toggleInterviewApplicants">
            <Interview :interview="interviewsOnly" :fromSearchBar="true" />
          </div>
          <span class="icon-text-label">面接実施絞込</span>
        </div>
        
        <!-- CSV download button with label -->
        <div class="icon-button-wrapper" v-show="isReviewer">
          <div class="favorite-wrapper tooltip-container" @click="showFilterForm">
            <button class="btn-plain btn-heart csv-icon-btn">
              <img src="../../../assets/images/CsvBtn.svg" alt="CSV出力">
            </button>
          </div>
          <span class="icon-text-label">CSV出力</span>
        </div>
        
        <!-- SaveSearch button with label -->
        <div class="icon-button-wrapper" v-show="isReviewer">
          <div class="favorite-wrapper tooltip-container" @click="showSearchModal">
            <button class="btn-plain btn-heart save-search-icon-btn">
              <img src="../../../assets/images/SaveSearch.svg" alt="保存条件検索">
            </button>
            <div class="custom-tooltip">保存条件検索</div>
          </div>
          <span class="icon-text-label">保存条件検索</span>
        </div>
      </div>
      
      <!-- Spacer to push right items to the end -->
      <div v-if="!aiMode" style="flex: 1;"></div>

      <!-- Favorite Only for non-reviewers at the end -->
      <div v-if="!isReviewer && !aiMode" class="icon-button-wrapper">
        <div class="favorite-wrapper tooltip-container" @click="toggleFavoriteApplicants">
          <Favorite :favorite="favoritesOnly" :fromSearchBar="true" />
        </div>
        <span class="icon-text-label">ブックマーク絞込</span>
      </div>

      <!-- Search buttons at the end (only for reviewer) -->
      <template v-if="isReviewer && !aiMode">
        <button
          type="button"
          class="btn btn-clear"
          @click="clearSearch"
          v-if="!isNoSearch"
        >
          検索クリア
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="showTitleModal"
          v-if="!isNoSearch"
        >
          検索条件保存
        </button>
        <button
          type="button"
          class="btn btn-primary btn-search"
          @click="showSearchForm"
        >
          <div class="d-flex align-items-center" style="justify-content: space-evenly;">
            <span class="font-16">検索</span>
          </div>
        </button>
      </template>
    </div>

    <!-- Second line: AI match button, right-aligned below the search buttons -->
    <div
      v-if="isReviewer && aiMatchingAuthority"
      class="d-flex justify-content-end mt-2"
      style="margin-right: 55px"
    >
      <button
        type="button"
        class="btn"
        :class="aiMode ? 'btn-ai-match-back' : 'btn-ai-match'"
        @click="toggleAiMode"
      >
        {{ aiMode ? '戻る' : 'AIマッチ' }}
      </button>
    </div>

    <!-- Full-width separator line -->
    <div v-if="!aiMode" class="full-width-line"></div>

    <!-- Second line: Checkbox and dropdown -->
    <div v-if="!aiMode" class="d-flex flex-wrap align-items-center mt-1" style="gap: 15px;">
      <!-- Dropdown -->
      <div>
        <b-dropdown
          id="actionDropdown"
          ref="bulkActionDropdown"
          :text="bulkActionLabel"
          class="btn-sm-drop dd-button"
          @shown="$emit('shown')"
          @hidden="resetBulkAction"
          variant="secondary"
          :disabled="jobseekerIds.length === 0"
          :class="{ 'active-bulk-btn': jobseekerIds.length > 0 }"
        >
          <!-- Level 1: Main Menu -->
          <li class="bulk-menu-item position-relative">
            <a href="#" class="dropdown-item d-flex justify-content-between align-items-center">
              ステータス一括更新
            </a>
            <div class="bulk-submenu" @click.stop>
              <div class="status-list p-2">
                <div v-for="(status, index) in client_status_list" :key="index" class="form-check mb-2">
                  <input class="form-check-input" type="radio" :id="'bulk-status-'+index" :value="status" v-model="selectedBulkStatus">
                  <label class="form-check-label ms-1" :for="'bulk-status-'+index" style="white-space: nowrap; cursor: pointer;">
                    {{ status }}
                  </label>
                </div>
              </div>
              <div class="text-center p-2 border-top">
                <button class="btn btn-primary btn-sm btn-block bulk-operation-btn" @click="applyBulkStatus">OK</button>
              </div>
            </div>
          </li>

          <b-dropdown-item v-if="isReviewer" @click="showReviewListModal = true">
            リストに振分け
          </b-dropdown-item>
          <!-- <b-dropdown-item v-if="isReviewer" @click="excludeApplicant">対象から除外</b-dropdown-item> -->

          <b-dropdown-item @click="openBulkMemoModal">メモ一括入力</b-dropdown-item>

        </b-dropdown>
      </div>
    </div>

    <FilterForm v-show="isReviewer && !aiMode" />
    <SearchForm v-show="isReviewer && !aiMode" />

    <b-modal
      ref="searchTitle"
      cancel-variant="outline-danger"
      cancel-title="キャンセル"
      ok-title="保存"
      title="検索条件保存"
      @ok.prevent="saveSearch"
      :ok-disabled="isSubmitting"
      @hidden="hideModal"
      modal-class="save-search-modal"
    >
      <form v-on:submit.prevent="saveSearch" data-vv-scope="saveSearch">
        <div class="custom-form-block" style="padding: 20px;">
          <div class="form-group row">
            <div class="col-md-12 mb-30">
              <label>
                検索条件名
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                v-bind:class="{
                  'is-invalid': errors && errors.title && errors.title.error,
                }"
                name="title"
                v-model="title"
                v-validate="'required'"
                placeholder="検索条件名を入力"
              />
              <div
                class="invalid-feedback"
                v-if="errors && errors.title && errors.title.error"
              >
                <span class="icon-error">!</span>
                {{ errors.title.msg }}
              </div>
            </div>

            <div class="col-md-12 mb-30">
              <div class="d-flex flex-row">
                <label class="mb-2">
                  ログイン時の初期表示条件にする
                  <span class="text-danger">*</span>
                </label>
                <div class="form-check ms-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="isDefault"
                    id="isDefaultCheck"
                    value="yes"
                    :checked="isDefault === 'yes'"
                    @click="handleRadioClick"
                    ref="defaultRadio"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <template #modal-footer>
        <button class="btn btn-white" @click="hideModal">キャンセル</button>
        <button class="btn btn-blue" @click="saveSearch">保存する</button>
      </template>
    </b-modal>
    
    <!-- Bulk Memo Modal -->
     <b-modal
       ref="bulkMemoModal"
       title="メモ一括入力"
       @ok.prevent="saveBulkMemo"
       cancel-title="キャンセル"
       ok-title="保存"
       :ok-disabled="loading"
     >
       <div class="d-block text-center">
        <b-form-textarea
          v-model="bulkMemoText"
          trim
          :rows="15"
          :max-rows="15"
        ></b-form-textarea>
       </div>
    </b-modal>

    <SearchTemplateModal
      ref="searchTemplate"
      :templates="userTemplate"
      :isSubmitting="isSubmitting"
      @hidden="hideModal"
    />

    <ReviewListPopup
      ref="reviewListPopup"
      :showReviewListModal="showReviewListModal"
      :isBulkOperation="true"
      :jobseekerIds="jobseekerIds"
      @hideModal="hideReviewList"
    />

    <ConfirmationPopup
      ref="confirmationPopUp"
      :modalText="detailsText"
      :buttonText="buttonText"
      @submit="processSubmission"
      @cancel="hideConfirmationModal"
      v-if="openConfirmationPopup"
    />
  </div>
</template>

<script>
import Favorite from '@/components/dashboard/applicants/Favorite.vue';
import Interview from '@/components/dashboard/applicants/Interview.vue';
import SearchForm from '@/components/dashboard/applicants/SearchForm.vue';
import FilterForm from '@/components/dashboard/applicants/FilterForm.vue';
import ReviewListPopup from '../ReviewListPopup.vue';
import SearchTemplateModal from './SearchTemplateModal.vue';
import ConfirmationPopup from './profile/ConfirmationPopup.vue';
import mutations from '@/config/mutations';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import Api from '@/config/api';
import ApiService from '@/service/apiService';

export default {
  name: 'SearchBar',
  components: {
    SearchForm,
    Favorite,
    Interview,
    FilterForm,
    ReviewListPopup,
    SearchTemplateModal,
    ConfirmationPopup,
  },
  data() {
    return {
      title: '',
      isDefault: 'no',
      errors: {
        title: {
          error: false,
          msg: '',
        },
      },
      isSubmitting: false,
      bulkActionType: null,
      bulkMemoText: '',
      showReviewListModal: false,
      openConfirmationPopup: false,
      selectedBulkStatus: null,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      applicants: ({ applicant }) => applicant.applicants,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      interviewsOnly: ({ applicant }) => applicant.interviewsOnly,
      sortBy: ({ applicant }) => applicant.sortBy,
      searchParams: ({ applicant }) => applicant.searchParams,
      checkAllState: ({ applicant }) => applicant.isCheckAll,
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      client_status_list: ({ applicant }) => applicant.client_status,
    }),
    isCheckAll: {
      get() {
        return this.checkAllState;
      },
      set(value) {
        this.setCheckAll(value);
      },
    },
    ...mapGetters({
      applicantsCount: 'getApplicantCounts',
      isReviewer: 'isCreateReviewUser',
      userTemplate: 'getCurrentUserSearchTemplate',
      selectedJd: 'jd/getSelectedJd',
      assignedReviewLists: 'getAssignedReviewLists',
      aiMatchingAuthority: 'getAiMatchingAuthority',
      aiMode: 'getAiMode',
    }),
    assignedReviewListName() {
      if (this.assignedReviewLists && this.assignedReviewLists.length > 0) {
        return this.assignedReviewLists[0].title;
      }
      return '';
    },
    bulkActionLabel() {
      return '一括操作 ▼';
    },
    isNoSearch() {
      if (this.selectedJd && Object.keys(this.selectedJd).length > 0) return false;
      return Object.keys(this.searchParams).length === 0 && this.sortBy === '';
    },
    detailsText() {
      return 'スカウトする求人が選択されていません<br/> このままスカウト候補へ追加しますか？';
    },
    buttonText() {
      return 'スカウト候補へ追加';
    },
  },
  methods: {
    ...mapMutations([
      mutations.applicant.TOGGLE_FAVORITES,
      mutations.applicant.TOGGLE_INTERVIEWS,
      mutations.applicant.TOGGLE_SEARCH_MODAL,
      mutations.applicant.TOGGLE_FILTER_MODAL,
      mutations.applicant.CHANGE_SORT_COLUMN,
      mutations.applicant.CHANGE_SEARCH_PARAMS,
      'setNewTemplate',
      'setCheckAll',
      'setReloadApplicants',
      'setJobseekerIds',
      'mutateApplicantsAfterMultipleStatus',
      'setLoading',
    ]),
    ...mapMutations({
      clearAll: 'jd/clearAll',
      setSelectedJd: 'jd/setSelectedJd',
      setAiMode: 'setAiMode',
      resetAiMatchingState: 'resetAiMatchingState',
    }),
    toggleAiMode() {
      if (this.aiMode) {
        this.resetAiMatchingState();
      } else {
        this.setAiMode(true);
      }
    },
    ...mapActions({
      loadCurrentUserSearchTemplate: 'loadCurrentUserSearchTemplate',
    }),
    resetBulkAction() {
      this.bulkActionType = null;
      this.selectedBulkStatus = null;
    },
    closeBulkActionDropdown() {
      const dropdown = this.$refs.bulkActionDropdown;
      if (dropdown && typeof dropdown.hide === 'function') {
        dropdown.hide();
      }
    },
    applyBulkStatus() {
      if (this.selectedBulkStatus) {
        this.changeStatus(this.selectedBulkStatus);
      }
    },
    openBulkMemoModal() {
      this.bulkMemoText = '';
      this.$refs.bulkMemoModal.show();
    },
    saveBulkMemo() {
      if (this.loading || this.jobseekerIds.length == 0 || !this.bulkMemoText.trim()) {
        return;
      }
      this.setLoading(true);
      ApiService.put(Api.endpoints.MULTIPLE_MEMO, {
        jobseekerIds: this.jobseekerIds,
        memo: this.bulkMemoText
      })
      .then(({ data }) => {
        this.setReloadApplicants(true);
        this.bulkMemoText = '';
        this.$refs.bulkMemoModal.hide();
        this.setCheckAll(false);
        this.setJobseekerIds([]);
        this.resetBulkAction();
      })
      .catch(({ response }) => {
        console.error(response);
        this.setLoading(false);
      })
      .finally(() => {
        // loading state is handled by setLoading and reloads
      });
    },
    async excludeApplicant() {
      if (this.jobseekerIds.length == 0) {
        return;
      }
      this.setLoading(true);
      ApiService.put(Api.endpoints.REMOVE_FROM_REVIEW_LIST_MULTIPLE, {
        jobseekerIDs: this.jobseekerIds,
        status: '未確認',
        isNewPanel: true,
      })
        .then(({ data }) => {
          this.mutateApplicantsAfterMultipleStatus(data.data);
          this.setReloadApplicants(true);
        })
        .catch((error) => {
          console.log(error);
          this.setLoading(false);
        })
        .then(() => {
          this.setJobseekerIds([]);
          this.setCheckAll(false);
          this.resetBulkAction();
        });
    },
    async scoutApplicant() {
      if (this.jobseekerIds.length == 0) {
        return;
      }
      this.setLoading(true);
      ApiService.put(Api.endpoints.MULTIPLE_STATUS, {
        jobseekerIDs: this.jobseekerIds,
        status: 'スカウト対象',
        isNewPanel: true,
      })
        .then(({ data }) => {
          this.mutateApplicantsAfterMultipleStatus(data.data);
          this.setReloadApplicants(true);
        })
        .catch((error) => {
          console.log(error);
          this.setLoading(false);
        })
        .then(() => {
          this.setJobseekerIds([]);
          this.setCheckAll(false);
        });
    },
    changeStatus(status) {
      if (this.jobseekerIds.length == 0) {
        return;
      }
      this.setLoading(true);
      ApiService.put(Api.endpoints.MULTIPLE_STATUS, {
        jobseekerIDs: this.jobseekerIds,
        status: status,
        isNewPanel: true
      })
        .then(({ data }) => {
          this.mutateApplicantsAfterMultipleStatus(data.data);
          this.setReloadApplicants(true);
          this.closeBulkActionDropdown();
        })
        .catch(({ response }) => {
           console.log(response);
           this.setLoading(false);
        })
        .then(() => {
          this.setJobseekerIds([]);
          this.setCheckAll(false);
          this.resetBulkAction();
        });
    },
    handleRadioClick(event) {
      if(this.isDefault === 'yes') {
        this.isDefault = 'no';
        event.target.checked = false;
      } else {
        this.isDefault = 'yes'
      }
    },
    hideReviewList() {
      this.showReviewListModal = false;
    },
    toggleFavoriteApplicants() {
      this[mutations.applicant.TOGGLE_FAVORITES](!this.favoritesOnly);
    },
    toggleInterviewApplicants() {
      this[mutations.applicant.TOGGLE_INTERVIEWS](!this.interviewsOnly);
    },
    showSearchForm() {
      this[mutations.applicant.TOGGLE_SEARCH_MODAL](true);
    },
    showFilterForm() {
      this[mutations.applicant.TOGGLE_FILTER_MODAL](true);
    },
    clearSearch() {
      this[mutations.applicant.CHANGE_SEARCH_PARAMS]({});
      this.clearAll();
      this.setSelectedJd(null);
      this[mutations.applicant.CHANGE_SORT_COLUMN]('');
    },
    isJdAssigned() {
      const selectedApplicants = this.applicants.filter(
        (applicant) => this.jobseekerIds.includes(applicant.id)
      );

      const hasUnassignedJd = selectedApplicants.some(
        (applicant) =>
          !applicant.markedjobseekers || applicant.markedjobseekers.length === 0
      );

      return !hasUnassignedJd;
    },
    async processSubmission() {
      this.openConfirmationPopup = false;
      this.scoutApplicant();
    },
    hideConfirmationModal() {
      this.openConfirmationPopup = false;
    },
    showTitleModal() {
      this.$refs.searchTitle.show();
    },
    showSearchModal(){
      this.$refs.searchTemplate.show();
    },
    hideModal() {
      this.$refs.searchTitle.hide();
      this.title = '';
      this.errors.title.error = false;
      this.errors.title.msg = '';
    },
    async saveSearch() {
      this.isSubmitting = true;
      const check = await this.$validator.validateAll('saveSearch');
      if (check) {
        this.errors.title.error = false;
        this.errors.title.msg = '';
        const params = { title: this.title, is_default: this.isDefault };

        if (this.searchParams) Object.assign(params, this.searchParams);
        if (this.sortBy) Object.assign(params, { sort: this.sortBy });
        Object.assign(params, { isNewPanel: true });

        ApiService.post(Api.endpoints.SAVE_SEARCH_TEMPLATE, params)
          .then(({ data }) => {
            this.setNewTemplate(data.data);
            this.isSubmitting = false;
            this.hideModal();
            this.title = '';
          })
          .catch(({ response }) => {
            this.parseErrorResponse(response);
            this.isSubmitting = false;
          });
      } else {
        this.isSubmitting = false;
        this.errors.title.error = true;
        this.errors.title.msg = '検索条件名は必須項目です';
      }
    },
  },
  watch: {
    title(value) {
      if (value === '') {
        this.errors.title.error = true;
        this.errors.title.msg = '検索条件名は必須項目です';
      } else {
        this.errors.title.error = false;
        this.errors.title.msg = '';
      }
    },
  },
  mounted() {
    this.loadCurrentUserSearchTemplate();
  },
};
</script>
<style scoped>
.bulk-operation-btn {
  border-color: rgb(98, 164, 253);
  background: rgb(98, 164, 253);
  min-width: 60px !important;
  width: 20px;
  margin: auto;
}

input[type="radio"] {
  width: 16px;
  height: 16px;
  border-color: #787878 !important;
}

.font-16 {
  font-size: 16px;
}

.form-control::placeholder {
  color: #b3b3b3 !important;
}


.custom-form-block label {
  color: #3c3c3c !important;
  font-size: 14px !important;
}

>>> .save-search-modal >>> .modal-header {
  border-bottom: none !important;
}

>>> .save-search-modal .modal-title {
  font-size: 20px;
}

>>> .dropdown-menu.show {
  width: 200px;
  min-width: 200px;
}

>>> .dropdown-item {
  font-size: 16px;
  padding: 5px 10px !important;
}

>>> .dropdown-item:hover {
  color: #006c6b!important;
  background-color: #f0f0f0;
}

>>> .dropdown .btn-secondary {
  background-color: #E5E7EB !important;
  color: #ffffff !important;
  border-color: #E5E7EB !important;
  height: 38px !important;
  min-width: 170px !important;
  border-radius: 5px !important;
  width: 170px !important;
  font-size: 14px !important;
  font-weight: bold !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

>>> .dropdown .btn-secondary:hover {
  background-color: rgba(0, 0, 0, 0.1) !important;
  border-color: rgba(0, 0, 0, 0.1) !important;
}

>>> .dropdown .dropdown-toggle::after {
  display: none !important;
}

.icon-button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  min-width: 95px;
  max-width: 95px;
}

.icon-button-wrapper .favorite-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 31px;
  margin: 0;
  padding: 0;
}

.icon-button-wrapper .favorite-wrapper .btn-plain {
  padding: 4px !important;
  margin: 0 !important;
  border: none !important;
  background: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.icon-button-wrapper .favorite-wrapper .btn-plain:hover {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.icon-text-label {
  font-size: 12px;
  color: #000000;
  text-align: center;
  white-space: nowrap;
  line-height: 1.2;
  font-weight: 700;
  width: 100%;
  display: block;
  margin: 0;
  padding: 0;
}

.csv-icon-btn,
.save-search-icon-btn {
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  background: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
}

.csv-icon-btn img,
.save-search-icon-btn img {
  width: 31px;
  height: 31px;
  display: block;
}

.favorite-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.btn-success {
  height: 38px;
  background: #009D9E;
  border-color: #009D9E;
  color: #fff;
  line-height: normal;
  margin: auto;
  min-width: 150px;
  width: 150px;
  font-size: 14px;
  font-weight: bold;
  padding: 5px 15px;
  border-radius: 5px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-search {
  height: 38px;
  line-height: normal;
  margin: auto;
  border-radius: 5px;
  min-width: 160px;
  width: 160px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-clear {
  height: 38px;
  background-color: #E5E7EB;
  border-color: #E5E7EB;
  color: #515C6B !important;
  font-weight: bold;
  font-size: 14px;
  line-height: normal;
  margin: auto;
  border-radius: 5px;
  min-width: 150px;
  width: 150px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-clear:hover,
.btn-clear:focus {
  background-color: #c2c9cc !important;
  border-color: #c2c9cc !important;
}

.btn-ai-match {
  height: 38px;
  min-width: 120px;
  border-radius: 20px;
  background-color: #e455c7;
  border: 2px solid #e455c7;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  padding: 5px 20px;
}

.btn-ai-match:hover {
  background-color: #c93aab;
  border-color: #c93aab;
  color: #fff;
}

.btn-ai-match-back {
  height: 38px;
  min-width: 120px;
  border-radius: 20px;
  background-color: #d9d9d9;
  border: 2px solid #d9d9d9;
  color: #333;
  font-weight: bold;
  font-size: 14px;
  padding: 5px 20px;
}

.btn-ai-match-back:hover {
  background-color: #c2c2c2;
  border-color: #c2c2c2;
  color: #333;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  visibility: hidden;
  opacity: 0;
  background-color: #787878;
  color: white;
  text-align: center;
  border-radius: 10px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1000;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  pointer-events: none;
}

.custom-tooltip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #787878 transparent;
}

.active-bulk-btn >>> .btn-secondary {
  background-color: #5d7593 !important;
  color: white !important;
  border-color: #5d7593 !important;
}

.bulk-menu-item:hover .bulk-submenu {
  display: block;
}

.bulk-submenu {
  display: none;
  position: absolute;
  top: -8px;
  left: 100%;
  width: 280px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1050;
}

.form-check-input {
  margin-top: 0.3rem;
}

.list-name-box {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 8px 15px;
  background-color: #ffffff;
  min-width: 350px;
  max-width: 500px;
  font-size: 14px;
  color: #787878;
  height: 40px;
  display: flex;
  align-items: center;
}

>>> .dropdown-menu {
  overflow: visible !important;
}
</style>
